// List of used feature flags
export const APPOINTMENTS_FEATURE_FLAG = "appointments";
export const CALENDAR_FEATURE_FLAG = "calendarV2";
export const RECURRING_APPT_FEATURE_FLAG =
  "appointments_recurring_booking_feature_flag";
export const SWITCH_PLAN_FEATURE_FLAG = "switch_plan_feature_flag";
export const PLAN_LIST_FEATURE_FLAG = "new_plans_list_feature_flag";
export const APPT_MEMBER_STATUS_FEATURE_FLAG =
  "appt_member_status_feature_flag";
export const SHOW_PAYMENT_MIGRATION = "show_payment_migration_feature_flag";
export const MIGRATION_ASSISTANT_ASYNC_ACTIVATION =
  "migration_assistant_async_activation_feature_";
export const PLAN_CREATE_FEATURE_FLAG = "plan_create_react_feature_flag";
export const GET_STARTED_FEATURE_FLAG = "get_started_feature_flag";
export const DASHBOARD_2024_UX_FEATURE_FLAG = "dashboard_2024_ux_feature_flag";
export const SHOW_NEW_PP_PLAN_PAGE_FEATURE_FLAG = "show-new-pp-plan-page-2025";
export const SHOW_MEMBER_PROFILE_FEATURE_FLAG = "show-member-profile-core-2025";
export const AI_MEMBERSHIP_ASSISTANT_FEATURE_FLAG = "ai-plans-assistant";
